













































import { Component } from "vue-property-decorator";

import {
  DialogSection,
  DialogForm,
  FormText,
  FormSelect
} from "sitewhere-ide-components";
import { VFlex } from "vuetify/lib";

import { IMqttOutboundConnectorConfiguration } from "sitewhere-configuration-model";
import { required } from "vuelidate/lib/validators";

@Component({
  components: { DialogForm, FormText, FormSelect, VFlex },
  validations: {
    protocol: {
      required
    },
    hostname: {
      required
    },
    port: {
      required
    },
    outboundTopic: {
      required
    }
  }
})
export default class MqttConnectionFields extends DialogSection {
  protocol = "tcp";
  hostname: string | null = null;
  port = 1883;
  outboundTopic: string | null = null;

  protocols: { text: string; value: string }[] = [
    {
      text: "TCP",
      value: "tcp"
    },
    {
      text: "TLS",
      value: "tls"
    }
  ];

  /** Reset section content */
  reset(): void {
    this.protocol = "tcp";
    this.hostname = null;
    this.port = 1883;
    this.outboundTopic = null;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IMqttOutboundConnectorConfiguration): void {
    this.protocol = input.protocol || "tcp";
    this.hostname = input.hostname;
    this.port = input.port || 1883;
    this.outboundTopic = input.outboundTopic;
  }

  /** Save form data to an object */
  save(): {} {
    return {
      protocol: this.protocol,
      hostname: this.hostname || "",
      port: this.port,
      outboundTopic: this.outboundTopic || "",
    };
  }
}
